import React, {useEffect, useMemo, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-enterprise';
import {AlpineContainer} from './gridContainer';
import {useGridLayout} from '../../contextProviders/gridLayoutContext';
require('./grid-styles.scss');


const MyGrid = (props) => {
  // The user's saved column layout for this grid, held server side. `props.ls_name`
  // is the grid's key. See contextProviders/gridLayoutContext.
  const {layout: savedLayout, saveLayout} = useGridLayout(props.ls_name);
  const columnApiRef = useRef(null);
  // The column state last pushed to, or pulled from, the grid, so a save does not
  // bounce back and re-apply itself.
  const syncedLayoutRef = useRef(null);
  const [initialLayout, setInitialLayout] = useState(null);

  const defaultColDef = useMemo( ()=> ({
    flex: 1,
    filter: true,
    resizable: true,
    sortable: false,
    floatingFilter: true,
    suppressMenu: true
  }), []);

  const onColumnMoved =(params)=> {
    const columnState = params.columnApi.getColumnState();
    syncedLayoutRef.current = JSON.stringify(columnState);
    saveLayout(columnState);
  };
  const applySavedLayout = ()=> {
    if(!columnApiRef.current || !savedLayout) return;

    const serialized = JSON.stringify(savedLayout);
    if(syncedLayoutRef.current === serialized) return;

    syncedLayoutRef.current = serialized;
    columnApiRef.current.applyColumnState({state: savedLayout, applyOrder: true});
  };

  const onGridReady = (params)=> {
    columnApiRef.current = params.columnApi;
    props.registerGrid(params);
    applySavedLayout();
  };

  // Covers the layout arriving from the server after the grid is already up.
  useEffect(applySavedLayout, [savedLayout]);

  // Only the first layout we see orders the column defs; everything after that is
  // applied to the live grid above. See the same note in paginatedGridWrapper.
  useEffect(()=> {
    if(initialLayout || !savedLayout) return;
    setInitialLayout(savedLayout);
  }, [savedLayout, initialLayout]);

  const updateColumnOrder = ()=> {
    if(!props.ls_name) return props.columnDefs;
    const columnSavedState = initialLayout;
    try{
      if(columnSavedState) {
        let newColumnDef = new Array(props.columnDefs.length);
        props.columnDefs.forEach((el, i)=> {
          //console.log('el:::', el);
          const index = columnSavedState.findIndex((e)=> e.colId === el.field);
          newColumnDef[index] = el;
        });
        return newColumnDef;
      } else {
        return props.columnDefs;
      }
    } catch(e) {
      return props.columnDefs;
    }
  };


  const getGridDefaultOptions =()=> {
    return {
      reactUi: 'true',
      className: 'ag-theme-alpine',
      animateRows: 'true',
      onColumnMoved: onColumnMoved,
      defaultColDef: defaultColDef,
      enableCellTextSelection: true,
      rowSelection: 'multiple',
      suppressHorizontalScroll: false,
    };
  };

  return (
    <AlpineContainer>

      <AgGridReact
        {...getGridDefaultOptions()}
        getContextMenuItems={props.contextMenu}
        columnDefs={updateColumnOrder()}
        rowData={props.rowData}
        frameworkComponents={props.components}
        onGridReady={onGridReady}
        // onDragStopped={(p)=> {
        //   const colIds = p.columnApi.getAllDisplayedColumns().map(col => col.colId)
        //   console.log(colIds)
        // }}

        // onSortChanged={onSortChange}
        // onFilterChanged={onFilterChanged}
        //bodyScroll = {log}

        // onComponentStateChanged={()=> {console.log('onComponentStateChanged')}}
      />
    </AlpineContainer>
  );
};

MyGrid.propTypes = {
  ls_name: PropTypes.string.isRequired,
  columnDefs: PropTypes.instanceOf(Object).isRequired,
  contextMenu: PropTypes.instanceOf(Array).isRequired,
  rowData: PropTypes.instanceOf(Array).isRequired,
  components: PropTypes.instanceOf(Array),
  registerGrid: PropTypes.func.isRequired,
};

MyGrid.defaultProps = {
  components: [],
};
export default MyGrid;